import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'
import { formatDate } from '../../../shared/constants'

function StoreView({ store }) {
  const data = [
    { label: 'Store Code', data: store.storeCode },
    { label: 'Name', data: store.name },
    { label: 'Region', data: store.region ? store.region.name : '' },
    { label: 'Zone', data: store.zone ? store.zone.name : '' },
    { label: 'State', data: store.state ? store.state.name : '' },
    { label: 'District', data: store.district ? store.district.name : '' },
    { label: 'City', data: store.city ? store.city.name : '' },
    { label: 'Area', data: store.area ? store.area.name : '' },
    { label: 'Email', data: store.email ? store.email : '' },
    { label: 'Mobile', data: store.phoneNumber ? store.phoneNumber : '' },
    { label: 'Pin Code', data: store.pinCode ? store.pinCode : '' },
    { label: 'Address', data: store.address ? store.address : '' },
    { label: 'GST', data: store.gst ? store.gst : '' },
    { label: 'Business Start Date', data: store.startDate ? formatDate(store.startDate) : '' },
  ]
  return (
    <Grid container>
      {store ? (
        <Grid item lg={12} container spacing={3}>
          {data.map((item, index) => (
            <Grid item lg={4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Loader />
      )}
    </Grid>
  )
}

export default StoreView
